import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@material-ui/styles";
import queryString from "query-string";

import log from "./utils/log";
import App from "./App";
import GlobalStyle from "./themes/globalStyle";
import { setPCUID, setPCSID } from "./utils/pcuid-cookie";
import ScrollToTop from "./components/ScrollToTop";

import accountSettingsAPI from "./data/account-settings";
import themeLoader from "./themes/loader";
import TradeData from './containers/TradeData';

const startTime = new Date();

const { pathname } = window.location;
const result = /trade\/ui\/([\w-]+)/g.exec(pathname);
const accountId = result && result[1];

const query = queryString.parse(window.location.search);
const { pcuid, pcsid } = query;
if (pcuid) {
  setPCUID(pcuid);
}

if (pcsid) {
  setPCSID(pcsid);
}

log.init({ accountId, pcuid });

const getAccountTheme = async accountId => {
  if (!accountId) {
    throw new Error("getAccountTheme: no account id");
  }
  const { franchises, removeColor } = await accountSettingsAPI({ accountId });
  return themeLoader(franchises, removeColor);
};

const renderApp = theme => {
  const ConnectedApp = () => (
    <Router basename="/trade/ui">
      <ScrollToTop />
      <ThemeProvider theme={theme}>
        <>
          <GlobalStyle />
          <TradeData>
            <App />
          </TradeData>
        </>
      </ThemeProvider>
    </Router>
  );

  ReactDOM.render(<ConnectedApp />, document.getElementById("root"));
  const preload = document.getElementById("preload");
  if (preload.remove) {
    preload.remove();
  } else {
    document.body.removeChild(preload);
  }
  log.info({ loadTime: Date.now() - startTime });
};

getAccountTheme(accountId)
  .catch(err => {
    // If getting account theme fails try again with no franchises (default theme)
    return themeLoader();
  })
  .then(renderApp, () => themeLoader());
